import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";

const ProductSearch = ({ setSearchQuery }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSearchQuery(value);
  };

  return (
    <div className="input-group mb-3 w-25">
      <span className="input-group-text border-0 pe-0">
        <FaSearch />
      </span>
      <input
        type="text"
        className="form-control border-0"
        placeholder="Search products"
        aria-label="Search"
        value={searchTerm}
        onChange={handleSearch}
        style={{ outline: "none", boxShadow: "none" }}
      />
    </div>
  );
};

export default ProductSearch;

